(function() {
  const PRODUCTS_PER_LOAD = 12;

  function initLoadMore() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const allItems = Array.from(grid.querySelectorAll('li[data-availability]'));
    if (allItems.length === 0) return;

    // Sortiere global
    const addToCart = allItems.filter(i => i.dataset.availability === 'available');
    const waitingList = allItems.filter(i => i.dataset.availability === 'waiting');
    const soldOut = allItems.filter(i => i.dataset.availability === 'sold-out');
    const sorted = [...addToCart, ...waitingList, ...soldOut];

    // Alle verstecken + neu sortiert anhängen
    sorted.forEach(item => {
      item.style.display = 'none';
      grid.appendChild(item);
    });

    // Erste 12 anzeigen
    let shown = 0;
    sorted.forEach(item => {
      if (shown < PRODUCTS_PER_LOAD) {
        item.style.display = '';
        shown++;
      }
    });

    // Load More Button
    const container = document.getElementById('load-more-container');
    if (!container) return;

    // Zeige Button wenn mehr als 12 Produkte
    if (sorted.length > PRODUCTS_PER_LOAD) {
      container.style.display = 'block';
    }

    const btn = document.getElementById('load-more-btn');
    if (!btn) return;

    btn.addEventListener('click', function() {
      let newShown = 0;
      sorted.forEach(item => {
        if (item.style.display === 'none' && newShown < PRODUCTS_PER_LOAD) {
          item.style.display = '';
          newShown++;
        }
      });

      const remaining = sorted.filter(i => i.style.display === 'none').length;
      if (remaining === 0) {
        container.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initLoadMore);
})();